import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { style } from '../../utils/style.js';
import { Headline } from '../Headline/Headline.js';
import { renderBonusBenefits } from './renderBonusBenefits.js';
export const BonusBenefitsBlock = JSX(({ bonusBenefits, cardTextAlign = 'text-center', className = '', columnsCount = '4', subtitle, title, ...rest }) => (_jsxs(BlockWrapper, { className: style('space-y-3xl', className), defaultPadding: "p-6xl", ...rest, children: [_jsx(Headline, { defaultPadding: "", title: title, description: subtitle, headlineVersion: "M" }), bonusBenefits?.length
            ? renderBonusBenefits(bonusBenefits, columnsCount, cardTextAlign)
            : null] })));
//# sourceMappingURL=BonusBenefitsBlock.js.map